export const apiCalculatedAttributesAppGroupIdTags = "/api/calculated_attributes/:app_group_id/tags";
